import { 
    IonContent,
    IonGrid,
    IonCol,
    IonRow,
    IonSelect,
    IonSelectOption,IonPopover,
     IonCard, IonButton, IonItem, IonInput, IonTabs, IonTabBar, IonTabButton, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCardContent, IonSegment, IonSegmentButton, IonLabel,
  } from '@ionic/react'
import { removeCookie  } from "../utils/cookie"
import {  useHistory} from 'react-router-dom';

import '../styles/style.css'

function UserLogout (props){

    let history = useHistory()

    return (
        <>
        
        <div className='logout-card desktop' id="click-trigger">
            <ion-avatar slot="start">
              <img src="../img/ryde-profile.png" />
              {/* <img src={props.memberData.profilePhoto} alt="profile"/> */}
            </ion-avatar>
            <ion-label>
              <h2>RYDE Technologies Pte Ltd</h2>
               <p>{props.memberData  ? props.memberData.firstName : "Lokesh" } | {props.memberData ? props.memberData.memberType : "Admin"}</p>
               <img className='down-arrow' src="../img/down.svg" />
            </ion-label>
        </div>
                <IonPopover trigger="click-trigger" triggerAction="click" dismissOnSelect={true}> {/* href='/rydeSend' */}
                    <IonContent class="ion-padding logout-popover">
                            
                            <a  onClick={()=>{
                        removeCookie('RydeSendToken') 
                        removeCookie('DeliveryDetails')
                        sessionStorage.clear()
                        history.push('/rydeSend')
                    }}><IonButton color="primary" mode='ios' >Logout</IonButton>
                       </a></IonContent>
                </IonPopover>

            
               
       
        </>
    )
}

export default UserLogout